import { TaxPricePeriodTranslationData } from "@/types/tax_price_period_translation";
import { TaxPricePeriodTranslationState } from "@/types/store/clientzone/tax_price_period_translation";

export const state: TaxPricePeriodTranslationState = {
  taxPricePeriodTranslation: [] as Array<TaxPricePeriodTranslationData>
}
